
import React, { useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { CheckCircle, ChevronRight, ChevronLeft } from 'lucide-react';
import './JobPostingForm.css';

const JobPostingForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const steps = [
    { number: 1, title: "Job Details" },
    { number: 2, title: "Location & Skills" },
    { number: 3, title: "Candidate Preferences" },
    { number: 4, title: "Screening Questions" },
  ];

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(prev => prev - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubmit = (stepData) => {
    const finalData = { ...formData, ...stepData };
    setFormData(finalData);
    setIsSubmitted(true);
    console.log("Final Form Data:", finalData);
    // In real app, you would submit to API here
    setTimeout(() => {
      alert("Job posted successfully!");
    }, 300);
  };

  if (isSubmitted) {
    return (
      <div className="form-submission-success">
        <CheckCircle size={64} className="success-icon" />
        <h2>Job Posted Successfully!</h2>
        <p>Your job listing is now live and visible to candidates.</p>
        <button 
          className="success-back-btn"
          onClick={() => {
            setIsSubmitted(false);
            setCurrentStep(1);
            setFormData({});
          }}
        >
          Post Another Job
        </button>
      </div>
    );
  }

  return (
    <div className="job-posting-form-container">
      {/* Progress Bar for Mobile */}
      <div className="mobile-progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
        />
        <div className="progress-text">
          Step {currentStep} of 4
        </div>
      </div>

      <div className="form-layout-wrapper">
        {/* Sidebar Steps */}
        <div className="steps-sidebar">
          <div className="steps-header">
            <h3>Steps to Post</h3>
          </div>
          
          <div className="steps-list">
            {steps.map((step) => (
              <div
                key={step.number}
                className={`step-item ${
                  currentStep > step.number
                    ? "step-completed"
                    : currentStep === step.number
                    ? "step-active"
                    : "step-pending"
                }`}
              >
                <div className="step-number-circle">
                  {currentStep > step.number ? (
                    <CheckCircle size={20} className="step-check-icon" />
                  ) : (
                    <span className="step-number-text">{step.number}</span>
                  )}
                </div>
                <div className="step-content">
                  <span className="step-title">{step.title}</span>
                  <span className="step-status">
                    {currentStep > step.number ? "Completed" : 
                     currentStep === step.number ? "In Progress" : "Pending"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Main Form Content */}
        <div className="form-main-content">
          <div className="form-step-header">
            <div>
              <h2 className="step-header-title">
                <span className="step-number-badge">Step {currentStep}</span>
                {steps[currentStep - 1].title}
              </h2>
              <p className="step-header-subtitle">
                {currentStep === 1 && "Provide basic job information to get started"}
                {currentStep === 2 && "Add location and required skills for this role"}
                {currentStep === 3 && "Set your preferred candidate qualifications"}
                {currentStep === 4 && "Add screening questions for applicants"}
              </p>
            </div>
          </div>

          <div className="form-step-container">
            {currentStep === 1 && <Step1 nextStep={nextStep} setFormData={setFormData} />}
            {currentStep === 2 && <Step2 nextStep={nextStep} prevStep={prevStep} setFormData={setFormData} />}
            {currentStep === 3 && <Step3 nextStep={nextStep} prevStep={prevStep} setFormData={setFormData} />}
            {currentStep === 4 && <Step4 prevStep={prevStep} onSubmit={handleSubmit} setFormData={setFormData} />}
          </div>

          {/* Navigation Buttons */}
          <div className="form-navigation">
            {currentStep > 1 && (
              <button
                type="button"
                className="nav-btn nav-btn-back"
                onClick={prevStep}
              >
                <ChevronLeft size={20} />
                Back
              </button>
            )}
            <div className="nav-buttons-right">
              {currentStep < 4 ? (
                <button
                  type="button"
                  className="nav-btn nav-btn-next"
                  onClick={nextStep}
                >
                  Continue to {steps[currentStep].title}
                  <ChevronRight size={20} />
                </button>
              ) : (
                <button
                  type="submit"
                  form="step4-form"
                  className="nav-btn nav-btn-submit"
                >
                  Post Job Now
                  <CheckCircle size={20} />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobPostingForm;